import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {UsagePoint} from '../../../models/rt2012/Enedis/UsagePoint';
import {UsagePoint as GazparUsagePoint} from '../../../models/rt2012/Gazpar/UsagePoint';
import {LogementService} from '../../../services/logement.service';
import {Logement} from '../../../models/logement';
import {ToastService} from '../../../services/toast.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '../../../../environments/environment';

@Component({
    selector: 'app-usage-point-selector',
    templateUrl: './usage-point-selector.component.html',
    styleUrls: ['./usage-point-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UsagePointSelectorComponent {

  @Input() logement: Logement;

  @Input() usagePoints: UsagePoint[];

  @Input() gazparUsagePoints: GazparUsagePoint[];

  @Output() usagePointSelected: EventEmitter<UsagePoint> = new EventEmitter();

  @Output() GazparUsagePointSelected: EventEmitter<GazparUsagePoint> = new EventEmitter();

  constructor(
    private logementService: LogementService,
    private toastService: ToastService,
    private router: Router,
    public modalService: NgbModal,
  ) {
  }

  onClickUsagePoint(usagePoint: UsagePoint) {
    this.usagePointSelected.emit(usagePoint);
    this.logementService.saveCaracteristiquePointLivraisonEnedis(this.logement, usagePoint.usagePointId)
      .then(data => {
        this.toastService.show(data.message, {classname: 'toast-' + data.status});
        this.router.navigate(['/rt2012/suivi-des-consommations']);
      });
  }

  onClickGazparUsagePoint(usagePoint: GazparUsagePoint) {
    this.GazparUsagePointSelected.emit(usagePoint);
    this.logementService.saveCaracteristiquePceGazpar(this.logement, usagePoint.pce.idPce)
      .then(data => {
        this.toastService.show(data.message, {classname: 'toast-' + data.status});
        window.location.href = environment.baseUrlBack + 'rt2012/suivi-des-consommations';
      });
  }
}
